import React, { useState } from "react";
import { deleteReportStatement, GetReportById } from "Services/OtherApis";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { isArabic } from "constants/isArabic";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";
import DownloadResume from "functions/download";
import OpenResumeInNewTab from "functions/openFileInNewTab";
import { MdOutlineDeleteOutline } from "react-icons/md";
function Table({
  data,
  loading,
  setDropDown,
  dropdown,
  dataTitles,
  isDropDown = false,
  getAllReportData,
}) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const [language, setSelectedLanguage] = useState(isRTL ? "ar" : "en");
  const [loadingResumes, setLoadingResumes] = useState({}); // Loading state for downloads
  const [loadingPreviews, setLoadingPreviews] = useState({}); // Loading state for previews
  const [loadingDelete, setLoadingDelete] = useState({});

  async function getResume(id, isPreview = false, name) {
    if (isPreview) {
      setLoadingPreviews((prev) => ({ ...prev, [id]: true })); // Start preview loading
    } else {
      setLoadingResumes((prev) => ({ ...prev, [id]: true })); // Start download loading
    }

    try {
      let res = await GetReportById(id);
      const resumeData = res?.file[language];

      if (!resumeData) {
        toast.error(t("No Report Available"));
        return;
      }

      if (isPreview) {
        const cleanedData = resumeData.replace(
          /^data:application\/pdf;base64,/,
          ""
        );
        OpenResumeInNewTab(cleanedData);
      } else {
        const cleanedData = resumeData.replace(
          /^data:application\/pdf;base64,/,
          ""
        );
        DownloadResume(cleanedData, name);
      }
    } catch (e) {
      toast.error(t("Error fetching Reports:"));
    } finally {
      if (isPreview) {
        setLoadingPreviews((prev) => ({ ...prev, [id]: false })); // Stop preview loading
      } else {
        setLoadingResumes((prev) => ({ ...prev, [id]: false })); // Stop download loading
      }
    }
  }

  async function deleteReport(id) {
    setLoadingDelete((prev) => ({ ...prev, [id]: true }));
    deleteReportStatement(id)
      .then((res) => {
        if (res?.status === 200) {
          toast.success(t("Successfully Deleted"));
        } else {
          toast.error(t("Error deleting report"));
        }
      })
      .finally(() => {
        getAllReportData();
        setLoadingDelete((prev) => ({ ...prev, [id]: false }));
        // setLoading(false);
      });
  }
  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        {isDropDown ? (
          <select
            onChange={(e) => setDropDown(e.target.value)}
            name="jobType"
            value={dropdown}
            className={`w-[400px] mt-1 p-2   border-gray-300  bg-gray-50 rounded-lg shadow-sm border  ${
              isRTL ? "text-right pr-10 pl-5" : ""
            }`}
          >
            <option value="All">{t("All Reports")}</option>
            {dataTitles.map((v, k) => {
              return <option value={v?.id}>{t(v?.name)}</option>;
            })}
          </select>
        ) : (
          <div className="font-semibold text-xl  tracking-wide">
            {t("Open Applicants")}
          </div>
        )}
      </div>
      {loading ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("Loading Jobs")} ...
        </p>
      ) : data?.length === 0 ? (
        <p className="text-gray-600 mt-4 text-center border border-gray-300  py-24 text-lg rounded-md">
          {t("No Jobs Available")} !
        </p>
      ) : (
        <div
          className={`overflow-x-auto relative  mt-4 bg-white p-3 rounded-lg `}
        >
          <table
            className={`w-full whitespace-nowrap  text-sm   ${
              isRTL ? "text-right" : "text-left"
            }`}
          >
            <thead className="text-md text-gray-500  bg-slate-100  font-normal">
              <th className=" px-4 py-4">{t("File Name")}</th>
              <th className=" px-4 py-4">{t("File Type")}</th>
              <th className=" px-4 py-4">{t("Action")}</th>
            </thead>
            <tbody
              className={`text-gray-500 ${language === "ar" && "text-lg"}`}
            >
              {data
                ?.filter((item) =>
                  dropdown === "" || dropdown === "All"
                    ? item
                    : item.type === dropdown
                )
                ?.map((v, k) => (
                  <tr
                    key={v._id}
                    className={`odd:bg-white even:bg-gray-50 ${
                      k % 2
                        ? "bg-gray-50 dark:bg-gray-600"
                        : "bg-white dark:bg-gray-700"
                    }}`}
                  >
                    <td
                      className={`border-b border-gray-300 px-4 py-4 ${
                        isArabic(v?.fileName[language])
                          ? " Majalla text-lg"
                          : ""
                      }`}
                    >
                      {v?.fileName[language]}
                    </td>

                    <td className={`border-b border-gray-300 px-4 py-4`}>
                      {t(v.type)}
                    </td>

                    <td className=" items-center border-b border-gray-300 px-4 py-4 flex flex-row  ">
                      <button
                        onClick={() => getResume(v?._id, true)}
                        className="text-gray-500 rounded-lg  cursor-pointer duration-300 hover:text-blue-600 flex items-center  w-10  "
                        disabled={loadingPreviews[v?._id]} // Disable only this button when clicked
                      >
                        {loadingPreviews[v?._id] ? (
                          <div className="flex items-center justify-center">
                            {/* <a>{t("Loading")} ... </a> */}

                            <svg
                              className="animate-spin h-7 w-7  text-white"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="white"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="white"
                                d="M4 12a8 8 0 018-8v8H4z"
                              ></path>
                            </svg>
                          </div>
                        ) : (
                          <div className="">
                            <a>
                              <IoEyeOutline className="text-[25px]" />
                            </a>
                          </div>
                        )}
                      </button>
                      <button
                        onClick={() =>
                          getResume(v?._id, false, v?.fileName[language])
                        }
                        className="text-gray-500 rounded-lg  cursor-pointer duration-300 hover:text-blue-600 flex items-center  w-10 "
                        disabled={loadingResumes[v?._id]} // Disable only this button when clicked
                      >
                        {loadingResumes[v?._id] ? (
                          <div className="flex items-center justify-center">
                            <svg
                              className="animate-spin h-7 w-7 mr-2 text-white"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="white"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="white"
                                d="M4 12a8 8 0 018-8v8H4z"
                              ></path>
                            </svg>
                          </div>
                        ) : (
                          <div className="">
                            <a>
                              {" "}
                              <MdOutlineFileDownload className="text-[28px] " />
                            </a>
                          </div>
                        )}
                      </button>
                      <button
                        onClick={() => deleteReport(v?._id)}
                        disabled={loadingDelete[v?._id]}
                        className="text-gray-500 rounded-lg  cursor-pointer duration-300 hover:text-blue-600 flex items-center  w-10 "
                      >
                        {loadingDelete[v?._id] ? (
                          <div className="flex items-center justify-center">
                            <svg
                              className="animate-spin h-7 w-7 mr-2 text-white"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="white"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="white"
                                d="M4 12a8 8 0 018-8v8H4z"
                              ></path>
                            </svg>
                          </div>
                        ) : (
                          <div className="flex items-center justify-center text-2xl">
                            <MdOutlineDeleteOutline />
                          </div>
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Table;
